/* -------------------------------------------------------------------------------------------------
Restricted - Copyright (C) Siemens Healthcare GmbH/Siemens Medical Solutions USA, Inc., 2020. All rights reserved
------------------------------------------------------------------------------------------------- */
export const resizeMixin = (superClass) =>
  class extends superClass {
    connectedCallback() {
      super.connectedCallback();
      /** @ignore */
      this.windowDimensionObserver = this.handleResize.bind(this);
      window.addEventListener('resize', this.windowDimensionObserver);
    }
    disconnectedCallback() {
      window.removeEventListener('resize', this.windowDimensionObserver);
      super.disconnectedCallback();
    }
  };
